import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

import ActivityGroupItem from '../ActivityGroupItem';

const ActivityList = styled.div`
  margin: ${props => props.margin};
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
`;

const ActivityGroupList = ({ margin, activityGroups, itemInCoach }) => (
  <ActivityList margin={margin}>
    {Object.values(activityGroups).map(activity => (
      <ActivityGroupItem key={activity.id} item={activity} itemInCoach={itemInCoach} />
    ))}
  </ActivityList>
);

ActivityGroupList.propTypes = {
  activityGroups: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  margin: PropTypes.string,
  itemInCoach: PropTypes.bool
};

ActivityGroupList.defaultProps = {
  margin: '0',
  itemInCoach: false
};

export default ActivityGroupList;



// WEBPACK FOOTER //
// ./src/components/ActivityGroupList/ActivityGroupList.jsx